import { useQuery } from '@tanstack/react-query';
import { captureException, fetchAllData, showNotification } from 'r/utils';
import { GET_ANALYSES, GET_ANALYSES_CMS } from 'r/utils/fetchApiRaw';
import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

type Analysis = {
  tweetID: string;
  pair: string;
  isPredictionUp: boolean;
};

export default function SyncCheckButton() {
  const { refetch, isFetching } = useQuery({
    queryKey: ['sync-check'],
    queryFn: async () => {
      try {
        const [cmsAnalyses, sanitizerAnalyses] = await Promise.all([
          (await fetchAllData(GET_ANALYSES_CMS, { noAuth: true, total: 5 }))
            .data as Array<Analysis>,
          (await fetchAllData(GET_ANALYSES, { noAuth: true, total: 5 }))
            .data as Array<Analysis>,
        ]);

        let isError = false;
        sanitizerAnalyses.forEach((sanitizerA) => {
          if (
            cmsAnalyses.every((cmsA) => {
              return (
                cmsA.tweetID !== sanitizerA.tweetID ||
                cmsA.pair !== sanitizerA.pair ||
                cmsA.isPredictionUp !== sanitizerA.isPredictionUp
              );
            })
          ) {
            isError = true;
            // eslint-disable-next-line no-console
            console.error(
              `Sanitized analysis ${sanitizerA.tweetID}:${sanitizerA.pair}:${sanitizerA.isPredictionUp} is missing in CMS`,
            );
          }
        });

        if (!isError) {
          showNotification('success', 'Sync Check passed successfully');
        } else {
          showNotification(
            'error',
            'Sync Check failed, check dev console for more info',
          );
        }

        return null;
      } catch (e) {
        captureException(e);
        throw e;
      }
    },
    enabled: false,
  });

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="outline"
            onClick={() => refetch()}
            disabled={isFetching}
          >
            <span className="m-auto">Sync Check</span>
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>
            Checks if all analyses from Sanitizer exist in CMS and highlights
            any missing records
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
